module.exports = __webpack_public_path__ + "img/logoCa.7d722a0b.jpg";